import { useWebsocketUpdates } from "@finbackoffice/site-core";
import { HoursRange, IClientError, IEventFeedResponse } from "@finbackoffice/websocket-client";
import { FC, useCallback, useMemo, useState } from "react";
import Loading from "components/base/loading/Loading";
import PrematchSportsAndTournamentsContainer from "components/pages/sport/upcoming/PrematchSportsAndTournamentsContainer";

interface IEventsState {
    data: IEventFeedResponse[];
    loading: boolean;
}

type IProps = {
    hoursRange: HoursRange;
};

const PrematchTopMatches: FC<IProps> = ({ hoursRange }) => {
    const [events, setEvents] = useState<IEventsState>({
        data: [],
        loading: true,
    });
    const [isFallback, setIsFallback] = useState(false);

    const onSocketUpdate = useCallback((events: IEventFeedResponse[], error: IClientError) => {
        if (!error) {
            if (events.length) {
                setEvents({
                    data: events,
                    loading: false,
                });
            } else {
                setIsFallback(true);
            }
        } else {
            setEvents((state) => ({
                ...state,
                loading: false,
            }));
        }
    }, []);

    const payload = useMemo(
        () => ({ hours: !isFallback ? hoursRange : HoursRange.FORTY_EIGHT }),
        [hoursRange, isFallback],
    );

    useWebsocketUpdates("top", onSocketUpdate, true, payload);

    if (events.loading) return <Loading />;

    return <PrematchSportsAndTournamentsContainer events={events.data} />;
};

export default PrematchTopMatches;
